import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'reducers';
import { useHistory, Link } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { 
	ArrowLeft, 
	UserIcon, 
	NotificationIcon, 
	ProfileIcon,
	LockIcon,
	MenuOpenIcon,
	LogoutIcon,
	WhatsappBlueIcon,
	InstagramBlueIcon
} from 'assets/icons';
import { Logo } from 'assets/img';
import { emit } from 'jetemit';

interface Props {
	className?: string;
	openProfile?: any;
	withLayout?: boolean;
	openPassword?: any;
	hideButtons?: boolean;
	useSocials?: boolean;
	onLogin?: any;
	withoutMenu?: boolean;
}

const logout = (dispatch: any,history: any) => {
	Globals.confirm('¿Desea cerrar sesión?',() => {
		dispatch({
			type: 'SET_USER',
			payload: null
		});
		history.replace('/client/quotes/request');
		Globals.quitLoading();
	});
}

const Header = (props: Props) => {
	const header = useSelector((state: RootState) => state.header);
	const subheader = useSelector((state: RootState) => state.subheader);
	const user = useSelector((state: RootState) => state.user);
	const [open,setOpen] = useState(false);
	const history = useHistory();
	const dispatch = useDispatch();
	const contact_info = useSelector((state: RootState) => state.contact_info);

	return (
		<div id="header" className={ props.className }>
			<div className={ `container-blue-top ${ props.withLayout ? 'without-shadow' : '' }` }>
				<div className="container-back-top">
					{
						user != null && !props.withoutMenu && (
							<div style={{
								flex: .2
							}}>
								<img className="menu-open" src={ MenuOpenIcon } onClick={ () => {
									emit('open-menu');
								} } />
								<img className="menu-open-responsive" src={ MenuOpenIcon } onClick={ () => {
									emit('open-menu-responsive');
								} } />
							</div>
						)
					}
					<div style={{
						flex: .6,
						textAlign: 'center'
					}}>
						<img src={ Logo } className="logo" />
					</div>
					<div style={{ flex: .2, display: 'flex', justifyContent: 'flex-end' }}>
						{
							!props.hideButtons && (
								<div className="container-buttons-top">
									{
										user != null ? (
											<>
												{
													props.useSocials ? (
														<div className="container-logout">
															<Link to="/client/profile" className="link-logout">
																{ user?.name }
															</Link>
															<a href={ contact_info?.instagram } target="_blank">
																<img src={ InstagramBlueIcon } />
															</a>
															<a href={ `https://wa.me/` + contact_info?.whatsapp } target="_blank">
																<img src={ WhatsappBlueIcon } />
															</a>
														</div>
													) : (
														<>
															{
																user?.level_id != Constants.LEVELS.CLIENT && (
																	<div onClick={ () => { setOpen(false); props.openProfile() } }>
																		<img src={ ProfileIcon } />
																	</div>
																)
															}
															<div onClick={ () => { setOpen(false); props.openPassword() } }>
																<img src={ LockIcon } />
															</div>
															<div onClick={ () => { setOpen(false); logout(dispatch,history) } }>
																<img src={ LogoutIcon } />
															</div>
														</>
													)
												}
											</>
										) : (
											<div className="container-logout">
												<Link to="/client/quotes/request" className="link-logout" onClick={ (e: any) => {
													if (props.onLogin) {
														e.preventDefault();
														props.onLogin();
													}
												} }>
													Iniciar Sesión
												</Link>
												<a href={ contact_info?.instagram } className="social-links" target="_blank">
													<img src={ InstagramBlueIcon } />
												</a>
												<a href={ `https://wa.me/` + contact_info?.whatsapp } className="social-links" target="_blank">
													<img src={ WhatsappBlueIcon } />
												</a>
											</div>
										)
									}
								</div>
							)
						}
					</div>
				</div>
			</div>		
		</div>
	)	
}

export default Header;